
































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
import GlobalMixins from "../../../global.mixin";
import FileManagementDialog from "./FileManagementDialog.vue";
import InventoryHistoryDialog from "./InventoryHistoryDialog.vue";
import {importExportApi} from "../../../services/api/importexport.api";
import DateRangePicker from "../../../components/DateRangePicker.vue";
import appSnackbarService from "../../../services/appSnackbar.service";

@Component({
  mixins: [GlobalMixins],
  components: {
    FileManagementDialog,
    InventoryHistoryDialog,
    DateRangePicker,
  }
})
export default class ArchivedProduct extends Vue {
  @State("products") productsState: any;
  @Action("getArchivedProducts") getArchivedProducts: any;
  @Action("restoreProduct") restoreProduct: any;
  @Action("updateDeleteStatus") updateDeleteStatus: any;

  @State("sites") sitesState: any;
  @Action("getSites") getSites: any;

  @State("deviceTypes") deviceTypesState: any;
  @Action("getDeviceTypes") getDeviceTypes: any;

  @State("productStates") productStatesState: any;
  @Action("getProductStates") getProductStates: any;

  @State("socketState") socketState: any;
  @Action("initializeSignalR") initializeSignalR: any;

  snackbar = false;
  snacktext = "";
  loader = false;
  search = "";

  inventoryHistoryDialog = false;
  selectedProduct = null;

  fileManagementDialog = false;
  restoreDialog = false;
  editDeleteStatusDialog = false;
  selectedDeleteStatus: number | null = null;

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "deletedDT",
    descending: true,
    page: 1,
    rowsPerPage: (this as any).$cookies.isKey("archived-products-rowsPerPage") ?
                        parseInt((this as any).$cookies.get("archived-products-rowsPerPage"), 10) : 25
  };
  totalItem = 2;

  showFilters = false;
  filters = {
      "productCode": "",
      "barCode": "",
      "description": "",
      "site.code": "",
      "site.description": "",
      "deviceType.name": "",
      "costCenter.name": "",
      "productState.name": "",
      "lastInventoryDate": { from: "", to: "" },
      "assignedDate": { from: "", to: "" },
      "activationDate": { from: "", to: "" },
      "deletedDT": { from: "", to: "" },
      "deleteStatusText": "",
    };

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  getHeaders() { return [
      {
        text: "#",
        value: "productId",
        filterCol: "productId",
        width: "1%",
        align: "left",
        filterable: false,
        filterType: "none"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_STATUS"),
        value: "status",
        filterCol: "status",
        width: "1%",
        sortable: false,
        filterable: false,
        filterType: "none"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_PRODUCT_CODE"),
        value: "productCode",
        filterCol: "productCode",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_PRODUCT_BAR_CODE"),
        value: "barCode",
        filterCol: "barCode",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_PRODUCT_NAME"),
        value: "description",
        filterCol: "description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_PRODUCT_SITE"),
        value: "site.code",
        filterCol: "site_code",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_PRODUCT_SITE_NAME"),
        value: "site.description",
        filterCol: "site_description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_PRODUCT_DEVICE_TYPE"),
        value: "deviceType.name",
        filterCol: "deviceType_name",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_PRODUCT_COST_CENTER"),
        value: "costCenter.name",
        filterCol: "costCenter_name",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_PRODUCT_PRODUCT_STATE"),
        value: "productState.name",
        filterCol: "productState_name",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_LAST_INVENTORY_DATE"),
        value: "lastInventoryDate",
        filterCol: "lastInventoryDate",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "dateRange"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_ACTIVATION_DATE"),
        value: "activationDate",
        filterCol: "activationDate",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "dateRange"
      },
      {
        text: (this as any).$t("ITEMS_TABLE_ASSIGNED_DATE"),
        value: "assignedDate",
        filterCol: "assignedDate",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "dateRange"
      },
      {
        text: "Törlés dátuma",
        value: "deletedDT",
        filterCol: "deletedDT",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "dateRange"
      },
      {
        text: "Törlés oka",
        value: "deleteStatusText",
        filterCol: "deleteStatusText",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: (this as any).$t("TABLE_ACTIONS"),
        value: "actions",
        filterCol: "actions",
        sortable: false,
        filterable: false,
        filterType: "none"
      }
    ];
  }

  async created() {
    await this.getSites();
    await this.getDeviceTypes();
    await this.getProductStates();

    this.initializeSignalR()
    .then( conn => {
      console.log("initializeSignalR - ok");
    })
    .catch( err => {
      console.error("initializeSignalR: ", err);
    });
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  triggerFilter() {
    this.serversideSearch();
  }

  toggleFilters() {
    if (this.showFilters) {
      // If hiding filters, clear all filter criteria
      this.clearFilters();
    }
    this.showFilters = !this.showFilters;
  }

  clearFilters() {
    this.filters = {
      "productCode": "",
      "barCode": "",
      "description": "",
      "site.code": "",
      "site.description": "",
      "deviceType.name": "",
      "costCenter.name": "",
      "productState.name": "",
      "lastInventoryDate": { from: "", to: "" },
      "assignedDate": { from: "", to: "" },
      "activationDate": { from: "", to: "" },
      "deletedDT": { from: "", to: "" },
      "deleteStatusText": "",
    };
    // Trigger search to refresh results without filters
    this.serversideSearch();
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    (this as any).$cookies.set("archived-products-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
      filters: JSON.stringify(this.filters)  // Serialize filters to JSON string
    };
    this.getArchivedProducts(page);
  }

  formatDate(date) {
    if (!date) {
      return "N/A";
    }
    return new Date(date).toLocaleDateString();
  }

  // File Management Methods
  showFileManagement(item) {
    this.selectedProduct = item;
    this.fileManagementDialog = true;
  }

  // Download methods
  downloadArchivedProductsData() {
    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: this.pagination.sortBy,
      descending: this.pagination.descending,
      page: this.pagination.page,
      rowsPerPage: this.pagination.rowsPerPage,
      searchString: x,
      filters: JSON.stringify(this.filters)
    };
    importExportApi.downloadArchivedProductExport(page, "archivalt-eszkozok-export.xlsx");
  }

  // Restore Methods
  showRestoreDialog(item) {
    this.selectedProduct = item;
    this.restoreDialog = true;
  }

  confirmRestore() {
    if (this.selectedProduct) {
      this.restoreProduct((this.selectedProduct as any).productId);
      this.restoreDialog = false;
      this.selectedProduct = null;
    }
  }

  showInventoryHistory(item) {
    this.selectedProduct = item;
    this.inventoryHistoryDialog = true;
  }

  showEditDeleteStatusDialog(item) {
    this.selectedProduct = item;
    // Set current delete status based on the item's deleteStatusText
    if (item.deleteStatusText === "Értékesítés") {
      this.selectedDeleteStatus = 1;
    } else if (item.deleteStatusText === "Selejt") {
      this.selectedDeleteStatus = 2;
    } else if (item.deleteStatusText === "Adomány") {
      this.selectedDeleteStatus = 3;
    } else {
      this.selectedDeleteStatus = 0;
    }
    this.editDeleteStatusDialog = true;
  }

  confirmEditDeleteStatus() {
    if (this.selectedProduct && this.selectedDeleteStatus !== null) {
      this.updateDeleteStatus({
        productId: (this.selectedProduct as any).productId,
        newStatus: this.selectedDeleteStatus
      });
      this.editDeleteStatusDialog = false;
      this.selectedProduct = null;
      this.selectedDeleteStatus = null;
    }
  }
}
